import { render, staticRenderFns } from "./PlanDetailsElement.vue?vue&type=template&id=a8b0a0fe"
import script from "./PlanDetailsElement.vue?vue&type=script&lang=js"
export * from "./PlanDetailsElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports